import style from './block.module.scss';
import { BlockWrapper, useEditor } from '@smartfire/js-block-engine';
import Button from '../button/block';
import SwiperPosts from './swiper/index.js';
import { useTranslation } from 'react-i18next';

function CrossActualite({ seeMorePosts, stripesBackground, category, categoriesAlias }) {
    if (categoriesAlias === '') {
        categoriesAlias = 'category';
    }
    const { isEditing } = useEditor();
    const { t } = useTranslation();

    return (
        <BlockWrapper.Div className={style.background}>
            {stripesBackground && <img src={stripesBackground[0]} alt="Decoration" className={style.decoration} />}
            <div className={style.block}>
                <h2 className={style.title}>{t('Aller plus loin')}</h2>
                <SwiperPosts posts={seeMorePosts} isEditing={isEditing} />
                <Button
                    text={t('Voir tous les articles')}
                    link={'/' + categoriesAlias + '/' + category[0].slug}
                    alignment="middle"
                    aspect="outlined"
                />
            </div>
        </BlockWrapper.Div>
    );
}

export default CrossActualite;
